import { render, staticRenderFns } from "./PrevilegeList.vue?vue&type=template&id=3f695369&scoped=true"
import script from "./PrevilegeList.vue?vue&type=script&lang=js"
export * from "./PrevilegeList.vue?vue&type=script&lang=js"
import style0 from "./PrevilegeList.vue?vue&type=style&index=0&id=3f695369&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f695369",
  null
  
)

export default component.exports